interface GetShadowOffsetsProps {
  distance: number;
  angle: number;
}

export const getShadowOffsets = ({
  distance,
  angle,
}: GetShadowOffsetsProps) => {
  const xOffset = distance * Math.sin((Math.PI * 2 * angle) / 360);
  const yOffset = -distance * Math.cos((Math.PI * 2 * angle) / 360);

  return {
    xOffset,
    yOffset,
  };
};

export interface BoxShadowValue {
  offsetX: number;
  offsetY: number;
  blurRadius: number;
  spreadRadius: number;
  color: { value: string; opacity: number };
}

export interface LegacyShadowParams {
  composite: unknown;
  angle: number;
  distance: number;
  blur: number;
  size: number;
  shadowColor: { value: string; opacity: number } | undefined;
}

/**
 * Resolves box shadow from either the composite boxShadow param
 * or the legacy individual shadow values.
 */
export const resolveBoxShadow = (
  params: LegacyShadowParams,
): BoxShadowValue => {
  if (
    params.composite &&
    typeof params.composite === 'object' &&
    'offsetX' in params.composite
  ) {
    return params.composite as BoxShadowValue;
  }

  const offsets = getShadowOffsets({
    angle: params.angle,
    distance: params.distance,
  });

  return {
    offsetX: offsets.xOffset,
    offsetY: offsets.yOffset,
    blurRadius: params.blur,
    spreadRadius: params.size,
    color: params.shadowColor
      ? {
          value: params.shadowColor.value || '#000000',
          opacity: params.shadowColor.opacity ?? 0.15,
        }
      : { value: '#000000', opacity: 0.15 },
  };
};
